// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTableContainer-root {
  max-height: calc(100% - 7rem);
  max-width: 100%;
  overflow: auto;
}

.MuiTooltip-tooltip {
  color: #ffffff !important;
  background: #9e9e9e !important;
}

.MuiBox-root {
  background: var(--Foreground);
}

.Mui-selected {
  background-color: var(--AccentColor) !important;
  color: var(--Foreground) !important;
}

.Mui-TableHeadCell-Content-Wrapper {
  white-space: nowrap !important;
}

.MuiSelect-select-MuiInputBase-input-MuiInput-input:focus {
  background-color: transparent !important;
}

.css-2otarv {
  background-color: #ffeb3b !important;
}

.css-1dm60hu {
  background-color: #948502 !important;
}

.css-gq270s:focus {
  background-color: var(--Foreground) !important;
}

.MuiTableRow-root td[data-pinned=true]:before,
.MuiTableCell-root[data-pinned=true]:before {
  background-color: var(--Hover) !important;
}

.MuiTableRow-root td[data-pinned=true],
.MuiTableCell-root[data-pinned=true] {
  background-color: var(--Hover) !important;
}
.MuiTableRow-root td[data-pinned=true] .Mui-TableHeadCell-Content .MuiBox-root,
.MuiTableCell-root[data-pinned=true] .Mui-TableHeadCell-Content .MuiBox-root {
  background-color: var(--Hover) !important;
}

.dashBoarBg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  overflow: auto;
  padding-right: 0.6rem;
}
.dashBoarBg .datafilteration {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dashBoarBg .datafilteration .sortingBtns {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.dashBoarBg .datafilteration .sortingBtns div {
  display: flex;
  gap: 0.6rem;
  padding: 0.3rem 0.6rem 0.3rem 0.6rem;
  border-radius: 0.3rem;
  align-items: center;
  cursor: pointer;
}
.dashBoarBg .datafilteration .sortingBtns div p {
  color: var(--TextColor);
  font-weight: 400;
}
.dashBoarBg .datafilteration button {
  background-color: var(--AccentColor);
  color: #ffffff;
  padding: 0.6rem 1.3rem 0.6rem 1.3rem;
  font-weight: 500;
  font-size: 0.875rem;
  border-radius: 0.3rem;
  outline: none;
}
.dashBoarBg .fullPageLoaderCont {
  width: 100%;
  height: 100%;
  position: relative;
}
.dashBoarBg .table {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex: 1 1;
  min-height: 20%;
  padding-bottom: 0.3rem;
  overflow: auto;
}
.dashBoarBg .table ::-webkit-scrollbar {
  width: 0.3rem;
  height: 0.3rem;
  background-color: var(--Foreground);
}
.dashBoarBg .table ::-webkit-scrollbar-thumb {
  background-color: var(--AccentColor);
  border-radius: 10px;
}
.dashBoarBg .table ::-webkit-scrollbar-track {
  background-color: var(--Foreground);
  border-radius: 10px;
}
.dashBoarBg .table ::-webkit-scrollbar-corner {
  background-color: var(--Foreground);
}
.dashBoarBg .table .tableBox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
}
.dashBoarBg .table .tableBox .pagination {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background-color: var(--Foreground);
  padding: 0.6rem 1.25rem;
  border-radius: 1.25rem;
}
.dashBoarBg .table .tableBox .pagination button {
  padding: 0.18rem;
  border-radius: 0.3rem;
  color: var(--TextColor);
}
.dashBoarBg .table .tableBox .pagination .pageButton {
  background-color: var(--AccentColor);
  color: white;
  font-size: 0.75rem;
}
.dashBoarBg .table .tableBox .pagination .pageButton:disabled {
  cursor: not-allowed;
  opacity: 0.8;
}
.dashBoarBg .table .tableBox .pagination .dataPerpage p {
  font-size: 0.8rem;
  color: var(--TextColor);
}
.dashBoarBg .table .tableBox .pagination div {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.dashBoarBg .table .tableBox .filterOption {
  position: absolute;
  z-index: 10;
  padding: 0.6rem;
  right: 5%;
  background-color: var(--Foreground);
  border-radius: 0.6rem;
  box-shadow: 0rem 0.25rem 0.5rem rgba(0, 0, 0, 0.2);
}
.dashBoarBg .table .tableBox .filterOption div {
  display: flex;
  align-items: center;
  margin-bottom: 0.6rem;
}
.dashBoarBg .table .tableBox .filterOption div input {
  margin-right: 0.6rem;
}
.dashBoarBg .table .tableBox .tableContainer {
  width: 100%;
  flex: 1 1;
  overflow: auto;
  background-color: var(--Foreground);
  border-radius: 1.25rem;
}
.dashBoarBg .table .tableBox .tableContainer .MuiPaper-root {
  height: 100%;
  background-color: var(--Foreground);
}
.dashBoarBg .table .tableBox .tableContainer .flagContainerActive {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 5px;
  height: 100%;
}
.dashBoarBg .table .tableBox .tableContainer .flagContainerActive::after {
  content: "";
  display: inline-block;
  width: 0.3rem;
  height: 100%;
  position: absolute;
  left: -0.5rem;
  top: 0;
  background-color: var(--AccentColor);
}
.dashBoarBg .table .tableBox .tableContainer .flagContainer {
  display: flex;
  align-items: center;
  position: relative;
  padding: 5px;
  height: 100%;
}
.dashBoarBg .table .tableBox .tableContainer .flagContainer::after {
  content: "";
  display: inline-block;
  width: 0.3rem;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: transparent;
}
.dashBoarBg .table .tableBox .tableContainer::-webkit-scrollbar {
  height: 0.3rem;
  width: 0.3rem;
}
.dashBoarBg .table .tableBox .tableContainer table {
  width: 100%;
  border-collapse: separate;
}
.dashBoarBg .table .tableBox .tableContainer table thead {
  box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2);
  position: sticky;
  top: 0;
  z-index: 9;
}
.dashBoarBg .table .tableBox .tableContainer table thead tr th {
  padding-top: 0rem 1.5rem;
}
.dashBoarBg .table .tableBox .tableContainer table tbody tr td.fixed-column {
  width: 9.3rem;
  z-index: 1;
  position: sticky;
  right: 0;
}
.dashBoarBg .table .tableBox .tableContainer table tbody tr td.fixed-column:hover {
  background-color: var(--Hover);
}
.dashBoarBg .table .tableBox .tableContainer table tbody tr:hover {
  background-color: var(--Hover);
}
.dashBoarBg .table .tableBox .tableContainer table th,
.dashBoarBg .table .tableBox .tableContainer table td {
  font-size: 0.8rem;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--TextColor);
  background-color: var(--Foreground);
}
.dashBoarBg .table .tableBox .tableContainer table .status {
  border-radius: 1.25rem;
  padding: 0.4rem 0.9rem;
  text-align: center;
  text-transform: capitalize;
  min-width: 8rem;
}
.dashBoarBg .table .tableBox .tableContainer table .completed {
  background-color: var(--Completed);
}
.dashBoarBg .table .tableBox .tableContainer table .pending {
  background-color: var(--Pending);
}
.dashBoarBg .table .tableBox .tableContainer table .inprogress {
  background-color: var(--Inprogress);
}
.dashBoarBg .table .tableBox .tableContainer table .accepted {
  background-color: var(--Accepted);
}
.dashBoarBg .table .tableBox .tableContainer table .re-initiated {
  background-color: var(--Reinitiated);
}
.dashBoarBg .table .tableBox .tableContainer table .cancelled {
  background-color: var(--Cancelled);
}
.dashBoarBg .table .tableBox .tableContainer table .invitation {
  background-color: var(--Invitation);
}
.dashBoarBg .table .tableBox .tableContainer table .fixed-column {
  width: 9.3rem;
  position: sticky;
  right: 0;
  z-index: 1;
  background-color: var(--Foreground);
  padding: 0.6rem 0.9rem;
}
.dashBoarBg .table .tableBox .tableContainer table .fixed-column div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dashBoarBg .table .tableBox .tableContainer table .fixed-column div p {
  color: var(--TextColor);
}
.dashBoarBg .table .tableBox .tableContainer table .fixed-column div svg {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/CandidateDetails/CandidateDashBoard.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,eAAA;EACA,cAAA;AACF;;AAKA;EACE,yBAAA;EACA,8BAAA;AAFF;;AAMA;EACE,6BAAA;AAHF;;AAMA;EACE,+CAAA;EACA,mCAAA;AAHF;;AAKA;EACE,8BAAA;AAFF;;AAIA;EACE,wCAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAGA;EACE,oCAAA;AAAF;;AAEA;EACE,8CAAA;AACF;;AAYA;;EAEE,yCAAA;AATF;;AAWA;;EAEE,yCAAA;AARF;AASE;;EACE,yCAAA;AANJ;;AAUA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;AAPF;AAQE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AANJ;AAOI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AALN;AAMM;EAEE,aAAA;EACA,WAAA;EACA,oCAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;AALR;AAMQ;EACE,uBAAA;EAEA,gBAAA;AALV;AASI;EACE,oCAAA;EACA,cAAA;EACA,oCAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AAPN;AAUE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AARJ;AAUE;EACE,aAAA;EACA,sBAAA;EAEA,mBAAA;EACA,WAAA;EAGA,SAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;AAXJ;AAaI;EACE,aAAA;EACA,cAAA;EACA,mCAAA;AAXN;AAaI;EACE,oCAAA;EACA,mBAAA;AAXN;AAaI;EACE,mCAAA;EACA,mBAAA;AAXN;AAaI;EACE,mCAAA;AAXN;AAaI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAXN;AAYM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mCAAA;EACA,uBAAA;EACA,sBAAA;AAVR;AAWQ;EAEE,gBAAA;EACA,qBAAA;EACA,uBAAA;AAVV;AAYQ;EACE,oCAAA;EACA,YAAA;EACA,kBAAA;AAVV;AAWU;EACE,mBAAA;EACA,YAAA;AATZ;AAcU;EACE,iBAAA;EACA,uBAAA;AAZZ;AAgBQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAdV;AAoBM;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,mCAAA;EACA,qBAAA;EACA,kDAAA;AAlBR;AAmBQ;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AAjBV;AAkBU;EACE,oBAAA;AAhBZ;AAoBM;EACE,WAAA;EAEA,SAAA;EACA,cAAA;EACA,mCAAA;EACA,sBAAA;AAnBR;AAoBQ;EACE,YAAA;EACA,mCAAA;AAlBV;AAoBQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAlBV;AAmBU;EACE,WAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,MAAA;EACA,oCAAA;AAjBZ;AAoBQ;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAlBV;AAmBU;EACE,WAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,6BAAA;AAjBZ;AAoBQ;EACE,cAAA;EACA,aAAA;AAlBV;AAqBQ;EACE,WAAA;EACA,yBAAA;AAnBV;AAsBU;EACE,wCAAA;EACA,gBAAA;EACA,MAAA;EAEA,UAAA;AArBZ;AAwBc;EACE,wBAAA;AAtBhB;AA+Cc;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,QAAA;AA7ChB;AA+CgB;EACE,8BAAA;AA7ClB;AAgDc;EACE,8BAAA;AA9ChB;AAmDU;;EAGE,iBAAA;EACA,gBAAA;EAGA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;AApDZ;AA8DU;EACE,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;AA5DZ;AA+DU;EACE,kCAAA;AA7DZ;AA+DU;EACE,gCAAA;AA7DZ;AA+DU;EACE,mCAAA;AA7DZ;AA+DU;EACE,iCAAA;AA7DZ;AA+DU;EACE,oCAAA;AA7DZ;AA+DU;EACE,kCAAA;AA7DZ;AA+DU;EACE,mCAAA;AA7DZ;AAgEU;EACE,aAAA;EACA,gBAAA;EACA,QAAA;EACA,UAAA;EACA,mCAAA;EACA,sBAAA;AA9DZ;AAgEY;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA9Dd;AAgEc;EACE,uBAAA;AA9DhB;AAgEc;EACE,eAAA;AA9DhB","sourcesContent":[".MuiTableContainer-root {\n  max-height: calc(100% - 7rem);\n  max-width: 100%;\n  overflow: auto;\n}\n// .MuiSvgIcon-root {\n//   fill: var(--TextColor) !important;\n// }\n\n.MuiTooltip-tooltip {\n  color: #ffffff !important;\n  background: #9e9e9e !important;\n}\n\n// .MuiTableRow-root,\n.MuiBox-root {\n  background: var(--Foreground);\n}\n\n.Mui-selected {\n  background-color: var(--AccentColor) !important;\n  color: var(--Foreground) !important;\n}\n.Mui-TableHeadCell-Content-Wrapper {\n  white-space: nowrap !important;\n}\n.MuiSelect-select-MuiInputBase-input-MuiInput-input:focus {\n  background-color: transparent !important;\n}\n\n.css-2otarv {\n  background-color: #ffeb3b !important;\n}\n.css-1dm60hu {\n  background-color: #948502 !important;\n}\n.css-gq270s:focus {\n  background-color: var(--Foreground) !important;\n}\n// .MuiTableCell-root {\n//   font-family: inherit !important;\n// }\n\n// .MuiButtonBase-root-MuiTableSortLabel-root .MuiTableSortLabel-icon {\n//   color: var(--Foreground) !important;\n// }\n\n// .MuiPaper-root {\n//   background: var(--Foreground) !important;\n// }\n.MuiTableRow-root td[data-pinned=\"true\"]:before,\n.MuiTableCell-root[data-pinned=\"true\"]:before {\n  background-color: var(--Hover) !important;\n}\n.MuiTableRow-root td[data-pinned=\"true\"],\n.MuiTableCell-root[data-pinned=\"true\"] {\n  background-color: var(--Hover) !important;\n  .Mui-TableHeadCell-Content .MuiBox-root {\n    background-color: var(--Hover) !important;\n  }\n}\n\n.dashBoarBg {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  overflow: auto;\n  padding-right: 0.6rem;\n  .datafilteration {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .sortingBtns {\n      display: flex;\n      align-items: center;\n      gap: 0.6rem;\n      div {\n        // background-color: var(--Foreground);\n        display: flex;\n        gap: 0.6rem;\n        padding: 0.3rem 0.6rem 0.3rem 0.6rem;\n        border-radius: 0.3rem;\n        align-items: center;\n        cursor: pointer;\n        p {\n          color: var(--TextColor);\n          // font-size: 15px;\n          font-weight: 400;\n        }\n      }\n    }\n    button {\n      background-color: var(--AccentColor);\n      color: #ffffff;\n      padding: 0.6rem 1.3rem 0.6rem 1.3rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      border-radius: 0.3rem;\n      outline: none;\n    }\n  }\n  .fullPageLoaderCont {\n    width: 100%;\n    height: 100%;\n    position: relative;\n  }\n  .table {\n    display: flex;\n    flex-direction: column;\n    // gap: .6rem;\n    align-items: center;\n    width: 100%;\n    // height: 65%;\n    // flex: 1;\n    flex: 1;\n    min-height: 20%;\n    padding-bottom: 0.3rem;\n    overflow: auto;\n    // max-height: 65%;\n    ::-webkit-scrollbar {\n      width: 0.3rem;\n      height: 0.3rem;\n      background-color: var(--Foreground);\n    }\n    ::-webkit-scrollbar-thumb {\n      background-color: var(--AccentColor);\n      border-radius: 10px;\n    }\n    ::-webkit-scrollbar-track {\n      background-color: var(--Foreground);\n      border-radius: 10px;\n    }\n    ::-webkit-scrollbar-corner {\n      background-color: var(--Foreground);\n    }\n    .tableBox {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 0.6rem;\n      .pagination {\n        display: flex;\n        align-items: center;\n        gap: 0.6rem;\n        background-color: var(--Foreground);\n        padding: 0.6rem 1.25rem;\n        border-radius: 1.25rem;\n        button {\n          // padding: 3px 3px 0px 3px;\n          padding: 0.18rem;\n          border-radius: 0.3rem;\n          color: var(--TextColor);\n        }\n        .pageButton {\n          background-color: var(--AccentColor);\n          color: white;\n          font-size: 0.75rem;\n          &:disabled {\n            cursor: not-allowed;\n            opacity: 0.8;\n          }\n        }\n\n        .dataPerpage {\n          p {\n            font-size: 0.8rem;\n            color: var(--TextColor);\n          }\n        }\n\n        div {\n          display: flex;\n          align-items: center;\n          gap: 0.6rem;\n          // p{\n          //     font-size: 13px;\n          // }\n        }\n      }\n      .filterOption {\n        position: absolute;\n        z-index: 10;\n        padding: 0.6rem;\n        right: 5%;\n        background-color: var(--Foreground);\n        border-radius: 0.6rem;\n        box-shadow: 0rem 0.25rem 0.5rem rgba(0, 0, 0, 0.2);\n        div {\n          display: flex;\n          align-items: center;\n          margin-bottom: 0.6rem;\n          input {\n            margin-right: 0.6rem;\n          }\n        }\n      }\n      .tableContainer {\n        width: 100%;\n        // height: calc(100% - 1.25rem);\n        flex: 1;\n        overflow: auto;\n        background-color: var(--Foreground);\n        border-radius: 1.25rem;\n        .MuiPaper-root {\n          height: 100%;\n          background-color: var(--Foreground);\n        }\n        .flagContainerActive {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          position: relative;\n          padding: 5px;\n          height: 100%;\n          &::after {\n            content: \"\";\n            display: inline-block;\n            width: 0.3rem;\n            height: 100%;\n            position: absolute;\n            left: -0.5rem;\n            top: 0;\n            background-color: var(--AccentColor);\n          }\n        }\n        .flagContainer {\n          display: flex;\n          align-items: center;\n          position: relative;\n          padding: 5px;\n          height: 100%;\n          &::after {\n            content: \"\";\n            display: inline-block;\n            width: 0.3rem;\n            height: 100%;\n            position: absolute;\n            left: 0;\n            top: 0;\n            background-color: transparent;\n          }\n        }\n        &::-webkit-scrollbar {\n          height: 0.3rem;\n          width: 0.3rem;\n        }\n\n        table {\n          width: 100%;\n          border-collapse: separate;\n          // border-spacing: 0rem 0.6rem;\n\n          thead {\n            box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2);\n            position: sticky;\n            top: 0;\n            // background-color: var(--Foreground);\n            z-index: 9;\n\n            tr {\n              th {\n                padding-top: 0rem 1.5rem;\n                // &:last-child {\n                //   z-index: 10;\n                //   position: sticky;\n                //   right: 0;\n                //   background-color: var(--Foreground);\n\n                //   div {\n                //     display: flex;\n                //     align-items: center;\n                //     justify-content: space-between;\n                //     img {\n                //       cursor: pointer;\n                //     }\n                //   }\n                // }\n              }\n            }\n          }\n\n          tbody {\n            tr {\n              // &:not(:first-child) {\n              //   margin-bottom: 0.6rem;\n              // }\n              td.fixed-column {\n                width: 9.3rem;\n                z-index: 1;\n                position: sticky;\n                right: 0;\n                // background-color: var(--Foreground);\n                &:hover {\n                  background-color: var(--Hover);\n                }\n              }\n              &:hover {\n                background-color: var(--Hover);\n              }\n            }\n          }\n\n          th,\n          td {\n            // padding: 0.6rem 1.5rem;\n            font-size: 0.8rem;\n            text-align: left;\n            // width: auto;\n            // max-width: 15rem;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            color: var(--TextColor);\n            background-color: var(--Foreground);\n          }\n\n          // .completed,\n          // .pending,\n          // .inProgress,\n          // .accepted,\n          // .reInitiated,\n          // .cancelled,\n          // .invited,\n          .status {\n            border-radius: 1.25rem;\n            padding: 0.4rem 0.9rem;\n            text-align: center;\n            text-transform: capitalize;\n            min-width: 8rem;\n          }\n\n          .completed {\n            background-color: var(--Completed);\n          }\n          .pending {\n            background-color: var(--Pending);\n          }\n          .inprogress {\n            background-color: var(--Inprogress);\n          }\n          .accepted {\n            background-color: var(--Accepted);\n          }\n          .re-initiated {\n            background-color: var(--Reinitiated);\n          }\n          .cancelled {\n            background-color: var(--Cancelled);\n          }\n          .invitation {\n            background-color: var(--Invitation);\n          }\n\n          .fixed-column {\n            width: 9.3rem;\n            position: sticky;\n            right: 0;\n            z-index: 1;\n            background-color: var(--Foreground);\n            padding: 0.6rem 0.9rem;\n\n            div {\n              width: 100%;\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n\n              p {\n                color: var(--TextColor);\n              }\n              svg {\n                cursor: pointer;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
